<template>
  <div v-if="sendJobs.length" class="ssp">
    <button v-for="j in sendJobs" :key="j.id" type="button" class="ssp__pill" :class="'ssp__pill--' + j.status" @click="onClick(j)" :title="j.error || ''">
      <v-progress-circular v-if="j.status === 'sending'" indeterminate size="12" width="2" color="#7b5cd6" />
      <v-icon v-else-if="j.status === 'success'" x-small color="#2e7d32">mdi-check</v-icon>
      <v-icon v-else x-small color="#c62828">mdi-alert-circle</v-icon>
      <span class="ssp__label">{{ j.mode === 'close' ? 'Schließen' : 'Senden' }} · {{ j.label }}</span>
      <span v-if="j.status === 'error'" class="ssp__err">{{ j.error }}</span>
      <v-icon v-if="j.status !== 'sending'" x-small class="ml-1" @click.stop="dismissJob(j.id)">mdi-close</v-icon>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

// Schwebende Status-Pills für den Hintergrund-Versand (wie in Quelp).
export default {
  name: "SendStatusPills",
  computed: { ...mapGetters(["sendJobs"]) },
  methods: {
    ...mapActions(["dismissJob"]),
    onClick(j) {
      if (j.status === "error") this.$emit("open", j);
    },
  },
};
</script>

<style lang="scss" scoped>
.ssp {
  position: fixed; top: 10px; left: 50%; transform: translateX(-50%); z-index: 250;
  display: flex; flex-direction: column; align-items: center; gap: 6px; pointer-events: none;
  &__pill {
    pointer-events: auto; display: inline-flex; align-items: center; gap: 6px; max-width: 460px;
    background: #fff; border: 1px solid rgba(0, 0, 0, 0.08); border-radius: 999px; padding: 5px 10px 5px 12px;
    font-size: 12px; color: #282828; box-shadow: 0 4px 14px rgba(16, 24, 40, 0.14); cursor: default;
    &--success { background: #e8f5e9; border-color: rgba(46, 125, 50, 0.3); }
    &--error { background: #ffebee; border-color: rgba(198, 40, 40, 0.3); cursor: pointer; }
  }
  &__label { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 240px; }
  &__err { color: #c62828; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 180px; }
}
</style>
